import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { ModalComponent } from '../../modal/modal.component';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { TimeSheetPluginService } from './timesheet-plugin.service';

@Component({
    selector: 'timesheet-edit',
    templateUrl: './timesheet-edit.component.html',
    standalone: false
})
export class TimeSheetEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  public plugin: any;
  public currentItem: any;
  editForm: UntypedFormGroup;
  public processing = false;
  public timeSheets: any;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: TimeSheetPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service
      .updateTimeSheet(
        this.inspectionId,
        this.pluginId,
        _.map(model.timesheets, (el: any) => ({
          Date: el.Date,
          Hours: el.Hours,
          Minutes: el.Minutes
        }))
      )
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.timeSheets =
        this.plugin.config.TimeSheets != null
          ? this.plugin.config.TimeSheets.map((el: any) => {
              return {
                Date: el.Date,
                Hours: el.Hours,
                Minutes: el.Minutes
              };
            })
          : [];
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['timesheets'];
    control.removeAt(i);
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['timesheets'];
    control.push(this.initTimeSheet());
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['timesheets'];
  }

  initTimeSheet(el?: any) {
    return this.fb.group({
      Date: [el ? el.Date : '', Validators.required],
      Hours: [el ? el.Hours : 0],
      Minutes: [el ? el.Minutes : 0]
    });
  }

  initForm() {
    this.editForm = this.fb.group({
      timesheets: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['timesheets'];
    _.forEach(this.timeSheets, (el) => {
      control.push(this.initTimeSheet(el));
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, null, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
